import { Observable } from 'rxjs';

export class SearchResult {
  public AccountName: string;
  public Rank: number;
  public Title: string;
  public Filename: string;
  public HitHighlightedTitle: string;
  public Author: string;
  public AuthorOWSUSER: string;
  public Path: string;
  public Description?: string;
  public LastModifiedTime: Date;
  public FirstPublishedDate: Date;
  public HitHighlightedSummary: string;
  public FileExtension: string;
  public SiteName: string;
  public SiteTitle: string;
  public IsDocument: boolean;
  public IsContainer: boolean;
  public UniqueId: string;
  public Created: Date;
  public Culture: string;
  public PictureURL: string;
  public PictureThumbnailURL: string;
  public WorkEmail: string;
  public BaseOfficeLocation: string;
  public Department: string;
  public JobTitle: string;
  public PreferredName: string;
  public ViewsLifeTimeUniqueUsers: number;
  public RefinableInt00: number;
  public RefinableInt01: number;
  public BoolFieldNewsIsTopNewsOWSBOOL: string;
  public RefinableString20: string;
  public RefinableString21: string;
  public WebTemplate: string;
  public contentclass: string;
  public EditorOwsUser: string;
  public ModifiedBy: string;
  public SPWebUrl: string;
  public LikesCount: number;
  public ServerRedirectedURL: string;
  public GroupId: string;
  public Expanded: boolean;
  public RefinableString22: string;

  public ProgID: string;
  // The following are used to track pageclick in sharepoint
  public piPageImpression: string;
  public piSearchResultId: string;
  public piPageImpressionBlockType: string;
  public SourceId: string;
  public SearchTerm: string;

  public photoUrl$: Observable<any>;
  public modifiedByUser$?: Observable<any>;

  constructor(opt?: Partial<SearchResult>) {
    Object.assign(this, opt);
  }
}
